import {eachMonthOfInterval, format} from 'date-fns';
import {ptBR} from 'date-fns/locale';

export function getAllMonths() {
	const startDate = new Date(2023, 0, 1);
	const endDate = new Date(2023, 11, 31);
	const months = eachMonthOfInterval({
		start: startDate,
		end: endDate,
	});
	const formattedMonths = months.map(month => ({
		value: format(month, 'MM', {locale: ptBR}),
		slug: format(month, 'MMMM', {locale: ptBR}),
	}));
	return formattedMonths;
}
